export default "__VITE_ASSET__DuWJPqdE__"